import React, { useEffect, useState } from 'react';
import { GtmProductFeature } from '../../../types/go-to-market';
import { CARD_COLORS } from './ArchitectureDetailStyles';
import StbMarkdown from '../../security-toolbox-ui/StbMarkdown';


const ArchitectureFeatureCard: React.FC<{
  index: number,
  product: string,
  features: GtmProductFeature[],
  visible?: boolean,
}> = ({
  index = -1,
  product = "",
  features,
  visible = false
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [displayFeatures, setDisplayFeatures] = useState<GtmProductFeature[]>([]);
  useEffect(() => {
    if (visible) {
      setDisplayFeatures(features);
      setIsClosing(false);
    } else if (displayFeatures.length > 0) {
      setIsClosing(true);
    }
  }, [visible, features, displayFeatures.length]);  

  let highLight = 'outline-gray-20';
  if (index !== null && index >= 0) {
    const highlightIdx = index % CARD_COLORS.length;
    highLight = CARD_COLORS[highlightIdx];
  }

  const handleTransitionEnd = (e: React.TransitionEvent<HTMLDivElement>) => {
    if (e.propertyName === 'opacity' && !visible) {
      setDisplayFeatures([]);
      setIsClosing(false);
    }
  };

  return (
    <div
      className={`grid min-h-0 transition-[opacity,margin,grid-template-rows] duration-500 rounded-xl ${visible ? `opacity-100 mb-4` : 'opacity-0 mb-0'}`}
      style={{ gridTemplateRows: visible || isClosing ? '1fr' : '0fr' }}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className={`px-4 mx-1 min-h-0 overflow-hidden transition-[padding,margin] duration-500 ${visible || isClosing ? 'py-4 my-1' : 'py-0 my-0'} outline rounded-xl outline-2 ${highLight}`}>
        <div className="text-cisco-blue-60">{product}</div>
        {displayFeatures && displayFeatures.length > 0 && displayFeatures.map((feature) => 
          <div key={feature.id} className="pb-4">
            <h4 className="font-semibold mb-2">{feature.name}</h4>
            <div className="text-left">
              {feature?.description
                ? <StbMarkdown>{feature.description}</StbMarkdown>
                : <div className="italic text-gray-50">No description provided.</div>
              }
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ArchitectureFeatureCard;